import { ApolloConsumer, ApolloProvider } from "@apollo/client";
import {
  CustomThemeProvider,
  DEFAULT_THEME_OPTIONS,
  getJwt,
} from "@brandclub/common-ui";
import { StyledEngineProvider } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { SplitFactory } from "@splitsoftware/splitio-react";
import React from "react";
import { Provider as BusProvider } from "react-bus";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import reduxApolloClient from "./redux/reduxApolloClient";
import { default as getStore, default as store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import { queryClient } from "./queryClient";

// Create the config for the SDK factory.
const sdkConfig: SplitIO.IBrowserSettings = {
  core: {
    authorizationKey: "fm4ur66cflc3lt0jjrh6j3olsu0iebp4ji1j",
    key: "key",
  },
};

const container = document.getElementById("root");
const root = createRoot(container as any);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApolloProvider client={reduxApolloClient}>
        <ApolloConsumer>
          {(apolloClient) => (
            <Provider store={getStore(undefined, { apolloClient })}>
              <BusProvider>
                <SplitFactory config={sdkConfig}>
                  <StyledEngineProvider injectFirst>
                    <CustomThemeProvider themeOptions={DEFAULT_THEME_OPTIONS}>
                      <App />
                    </CustomThemeProvider>
                  </StyledEngineProvider>
                </SplitFactory>
              </BusProvider>
            </Provider>
          )}
        </ApolloConsumer>
      </ApolloProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

if (
  window.location.href.includes(import.meta.env.VITE_APP_DEV_UI_URL) ||
  window.location.href.includes(import.meta.env.VITE_APP_LOCALHOST_UI_URL)
) {
  //@ts-ignore
  window.getJwt = async () => {
    const jwt = await getJwt();
    console.log({ jwt });
  };
  //@ts-ignore
  window.store = store;
  //@ts-ignore
  window.getState = () => store().getState();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
